import React from 'react';

// Styles & Assets
import styles from './RouteGeneralSlot.module.css';
import { ReactComponent as BinSvg } from '../../../assets/icons/bin.svg';

// Services
import { dateFormat } from '../../../services/parseDates';
import { getEnvironmentApiUrl } from '../../../services/General';

// Hooks
import { useState } from 'react';
import useHttp from '../../../hooks/useHttp';

// Components
import Icon from '../../UI/Icon/Icon';
import Modal from '../../UI/Modal/Modal';

// Interfaces
import { Route } from '../../../interfaces/routes';

// Language
import { useTranslation } from 'react-i18next';

// Other
import { Link } from 'react-router-dom';
import CancelConfirmButtons from '../../UI/CancelConfirmButtons/CancelConfirmButtons';

const RouteGeneralSlot: React.FC<{
    route: Route,
    deleteRoute: (id: number) => void
}> = ({ route, deleteRoute }) => {

    const { t } = useTranslation();

    const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false);

    const { sendRequest: deleteInquiry } = useHttp();

    const handleDeleteRoute = () => setShowDeleteDialog(true);

    const handleConfirmClick = () => {
        deleteInquiry({
            url: getEnvironmentApiUrl() + `route/${route.id}`,
            method: 'DELETE',
            body: {},
        });
        deleteRoute(route.id);
        setShowDeleteDialog(false);
    };

    return (
        <>
            <div className={styles.borderSeparator}></div>
            <div className={styles.routeSlotContainer}>
                <div className={styles.routeSlotLeft}>
                    <button onClick={handleDeleteRoute}>
                        <Icon>
                            <BinSvg />
                        </Icon>
                    </button>
                    <div>
                        <p className={styles.routeName}>{route.name}</p>
                        <span className={styles.creationDate}>
                            {t('creation_date')}: {dateFormat(route.date)}
                        </span>
                    </div>
                </div>
                <Link to={'/home/routes/set-up-route'} state={{ route }} className={styles.viewButton}>{t('view')}</Link>
            </div>
            <Modal show={showDeleteDialog} setShowModal={setShowDeleteDialog}>
                <div className={`${styles.deleteDialog} dialog`}>
                    <h1 className={styles.title}>{t('sure_delete_route')}</h1>
                    <CancelConfirmButtons
                        onCancel={() => setShowDeleteDialog(false)}
                        onConfirm={handleConfirmClick}
                    />
                </div>
            </Modal>
        </>
    );
};

export default RouteGeneralSlot;